import { registerActionExecutorFactory } from './actionExecutorRegistry';
import { DocActionsExecFactory } from './DocActionsExecFactory';
import { LinkedDocActionsExecFactory } from './LinkedDocActionsExecFactory';
import { ActivityActionsExecFactory } from './ActivityActionsExecFactory';
import { ProcessActionsExecFactory } from './ProcessActionsExecFactory';
import { AttachActionsExecFactory } from './AttachActionsExecFactory';
import { RouteMapActionsExecFactory } from './RouteMapActionsExecFactory';

export function registerActionExecutors() {
    registerActionExecutorFactory('doc', (act, throwError) => DocActionsExecFactory.GetActionExecutor(act, throwError));
    registerActionExecutorFactory('linkedDoc', (act, throwError) =>
        LinkedDocActionsExecFactory.GetActionExecutor(act, throwError),
    );
    registerActionExecutorFactory('activity', (act, throwError) =>
        ActivityActionsExecFactory.GetActionExecutor(act, throwError),
    );
    registerActionExecutorFactory('process', (act, throwError) =>
        ProcessActionsExecFactory.GetActionExecutor(act, throwError),
    );
    registerActionExecutorFactory('attach', (act, throwError) =>
        AttachActionsExecFactory.GetActionExecutor(act, throwError),
    );
    registerActionExecutorFactory('routeMap', (act, throwError) =>
        RouteMapActionsExecFactory.GetActionExecutor(act, throwError),
    );
}
